import { useScaleSize } from '@/hooks';

type CloseIconProps = {
    color?: string;
    width?: number;
    height?: number;
    className?: string;
    svgProps?: React.SVGProps<SVGSVGElement>;
};

const CloseIcon = ({ color = 'currentColor', width = 12, height = 13, className, svgProps }: CloseIconProps) => {
    const { scaleWidth, scaleHeight } = useScaleSize();

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={scaleWidth(width)}
            height={scaleHeight(height)}
            viewBox="0 0 12 13"
            fill="none"
            className={className}
            {...svgProps}
        >
            <path
                d="M10.9852 1.98518L6 6.97036M1.01482 11.9555L6 6.97036M6 6.97036L1.01482 1.98518M6 6.97036L10.9852 11.9555"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
            />
        </svg>
    );
};

export default CloseIcon;
